import { getStaffScopedApiPrefixOrCareAdvisor } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { CareCoordinationReport, ObjectType } from './types/types';

export const deleteCareCoordinationReportObject = async (
  care_coordination_report_id: string,
  object_id: string,
  object_type: ObjectType,
  userRole?: string,
): Promise<CareCoordinationReport> => {
  const prefix = getStaffScopedApiPrefixOrCareAdvisor(userRole);
  const { data } = await client.delete<CareCoordinationReport>(
    `${prefix}/care_coordination_reports/${care_coordination_report_id}/${object_type}/${object_id}`,
  );

  return data;
};
